/**
 * プロフィール入力フォームの選択肢定義
 *
 * バリデーション定義に準拠:
 * devdocs/docs/03_詳細設計/core-backend/api-user-config/02-プロフィールAPI.md
 */

import {
  UserGeneration,
  UserGender,
  UserPrefecture,
  UserReferralSource
} from "../generatedApi/unifiedApi";

// 年代選択肢
export const GENERATION_OPTIONS = [
  { value: UserGeneration._10_, label: "10代" },
  { value: UserGeneration._20_, label: "20代" },
  { value: UserGeneration._30_, label: "30代" },
  { value: UserGeneration._40_, label: "40代" },
  { value: UserGeneration._50_, label: "50代" },
  { value: UserGeneration._60_, label: "60代以上" }
] as const;

// 性別選択肢
export const GENDER_OPTIONS = [
  { value: UserGender.MALE, label: "男性" },
  { value: UserGender.FEMALE, label: "女性" },
  { value: UserGender.OTHER, label: "その他" },
  { value: UserGender.NO_ANSWER, label: "回答しない" }
] as const;

// 都道府県選択肢（プロフィール入力用）
export const PROFILE_PREFECTURE_OPTIONS = [
  { value: UserPrefecture.AICHI, label: "愛知県" },
  { value: UserPrefecture.GIFU, label: "岐阜県" },
  { value: UserPrefecture.MIE, label: "三重県" },
  { value: UserPrefecture.SHIZUOKA, label: "静岡県" }
] as const;

// refloopを知ったきっかけ選択肢
export const REFERRAL_SOURCE_OPTIONS = [
  { value: UserReferralSource.INSTAGRAM, label: "Instagram公式アカウント" },
  { value: UserReferralSource.TIKTOK, label: "TikTok公式アカウント" },
  { value: UserReferralSource.YOUTUBE, label: "YouTube公式アカウント" },
  { value: UserReferralSource.REFLOOP, label: "refloopマガジン（おでかけ記事）" },
  { value: UserReferralSource.GOOGLE_YAHOO, label: "Google / Yahoo 検索" },
  { value: UserReferralSource.REFERRAL, label: "知人からの紹介" },
  { value: UserReferralSource.OTHER, label: "その他" }
] as const;

export { UserGeneration, UserGender, UserPrefecture, UserReferralSource };
